import React from 'react';

import styled, { css, useTheme } from 'styled-components/macro';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';

const ArrowStyles = styled.div<{ direction: string }>`
  display: flex;
  position: absolute;
  top: 50%;
  ${({ direction }) =>
    direction === 'right'
      ? css`
          right: 25px;
        `
      : css`
          left: 25px;
        `};
  height: 50px;
  width: 50px;
  justify-content: center;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  align-items: center;
  transition: transform ease-in 0.1s;
  &:hover {
    transform: scale(1.1);
  }
  svg {
    transform: translateX(2px);
  } 
    &:focus {
      outline: 0;
    }
  }
`;

interface Props {
  direction?: any;
  handleClick?: any;
}
const Arrow = ({ direction, handleClick }: Props) => {
  const { colors } = useTheme();
  return (
    <ArrowStyles onClick={handleClick} direction={direction}>
      {direction === 'right' ? (
        <MdArrowForwardIos color={colors.primary[100]} size={20} />
      ) : (
        <MdArrowBackIos color={colors.primary[100]} size={20} />
      )}
    </ArrowStyles>
  );
};

export default Arrow;
